var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.99998H15.9C15.4215 1.67358 13.3751 0.003 11 0H8.99995C6.62484 0.003 4.57837 1.67358 4.09997 3.99998H0.999984C0.447703 3.99998 0 4.44769 0 4.99997C0 5.55225 0.447703 6 0.999984 6H1.99997V19C2.0033 21.76 4.23994 23.9967 6.99998 24H13C15.76 23.9967 17.9967 21.76 18 19V6H19C19.5523 6 20 5.5523 20 5.00002C20 4.44773 19.5523 3.99998 19 3.99998ZM9 17C9 17.5523 8.5523 18 8.00002 18C7.44769 18 6.99998 17.5523 6.99998 17V11C6.99998 10.4477 7.44769 10 7.99997 10C8.55225 10 8.99995 10.4477 8.99995 11V17H9ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V17ZM6.171 3.99998C6.59634 2.80228 7.72903 2.00152 9 1.99997H11C12.271 2.00152 13.4037 2.80228 13.829 3.99998H6.171Z",
    fill: "#2F4858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.696ee2c1ba5d8e4796a4b1b2637dec56.svg";
export { ForwardRef as ReactComponent };